export const DEFAULT_FILE_TYPE_CSV = 'csv';
export const DEFAULT_FILE_TYPE_EXCEL = 'excel';
export const DEFAULT_FILE_TYPE_PDF = 'pdf';
export const DEFAULT_FILE_TYPE_IMG_UPPERCASE = 'IMG';
export const FILE_TYPE_EXTENSION_CSV = '.csv';
